import React, { Component } from 'react';
import {
    Cell,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip
} from 'recharts';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import IconSquareCustom from '../../assets/icons/IconSquareCustom';
import IconTicketCompletion from '../../assets/icons/IconTicketCompletion';

const COLORS = ["#2E90FC", "#FBCA2E", "#2155A3", "#9DEFDC", "#FF6F00", "#AB3291", "#01B2BC", "#B8C16B", "#BADAD5", "#ECBD6C"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
        <text className="font-bold" x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
            {`${(percent * 100).toFixed(2)}%`}
        </text>
    );
};

class TicketTrendVolumeChartPrincipal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0
        }
    }

    checkColorComponent = (data, index) => {
        if (data.name === "ND6") {
            return COLORS[0];
        }
        if (data.name === "Nexmile") {
            return COLORS[1];
        }
        if (data.name === "NexFin") {
            return COLORS[2];
        }
        if (data.name === "GroMart") {
            return COLORS[3];
        }
        if (data.name === "NexChief") {
            return COLORS[4];
        }
        if (data.name === "NexPos") {
            return COLORS[5];
        }
    }

    render() {
        return (
            <>
                {/* Tren Volume Ticket*/}
                <div id="btntrenvolume" className="rounded-md shadow-lg col-span-3 row-span-2 bg-white cursor-pointer">
                    <div className="p-5">
                        <div className="text-xl font-bold flex items-center pb-5">
                            {
                                this.props.loading
                                    ? <Skeleton height={40} width={40} />
                                    : <IconTicketCompletion />
                            }
                            {
                                this.props.loading
                                    ? <Skeleton height={20} width={250} className="ml-2" />
                                    : <p className="text-nexcareblue1 pl-3">Tren Volume Tiket</p>
                            }
                        </div>

                        {
                            this.props.loading
                                ? <Skeleton height={250} />
                                : <div>
                                    {
                                        this.props.data.length > 0
                                            ? <div>
                                                <div className="flex text-nexcareblue1">
                                                    <div className="flex-auto w-4/12 font-medium text-lg">
                                                        <div className="flex items-center">
                                                            <IconSquareCustom squareColor="#2E90FC" className="mr-3" />
                                                            <span>{`ND6`}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <IconSquareCustom squareColor="#FBCA2E" className="mr-3" />
                                                            <span>{`Nexmile`}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <IconSquareCustom squareColor="#2155A3" className="mr-3" />
                                                            <span>{`Nexfin`}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <IconSquareCustom squareColor="#9DEFDC" className="mr-3" />
                                                            <span>{`Gromart`}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <IconSquareCustom squareColor="#FF6F00" className="mr-3" />
                                                            <span>{`Nexchief`}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <IconSquareCustom squareColor="#AB3291" className="mr-3" />
                                                            <span>{`Nexpos`}</span>
                                                        </div>
                                                    </div>

                                                    {
                                                        this.props.data[this.state.index].module.find(item => item.value > 0)
                                                            ? <div className="flex-auto w-8/12 h-72">
                                                                <ResponsiveContainer height="100%">
                                                                    <PieChart>
                                                                        <Pie
                                                                            data={this.props.data[this.state.index].module.filter(item => item.value > 0)}
                                                                            cx="40%"
                                                                            cy="40%"
                                                                            labelLine={false}
                                                                            label={renderCustomizedLabel}
                                                                            fill="#8884d8"
                                                                            dataKey="value"
                                                                            onClick={this.props.handlePopupTicketTrenVolume}
                                                                        >
                                                                            {this.props.data[this.state.index].module.map((entry, index) => (
                                                                                <Cell key={`cell-${index}`} fill={this.checkColorComponent(entry, index)} />
                                                                            ))}
                                                                        </Pie>
                                                                        <Tooltip />
                                                                    </PieChart>
                                                                </ResponsiveContainer>
                                                            </div>
                                                            : <div className="flex justify-center pt-20 text-lg font-medium w-8/12 h-72">
                                                                <p className="text-darkgrey">Tidak ada data</p>
                                                            </div>
                                                    }
                                                </div>

                                                <div className="pt-5 grid grid-rows-4 grid-flow-col gap-1 font-medium text-lg">
                                                    {
                                                        this.props.data.map((data, index) => {
                                                            return (
                                                                <div key={index} className={this.state.index === index ? "flex items-center text-nexcareblue1" : "flex items-center text-lightblue"} onClick={() => this.setState({ index })}>
                                                                    <IconSquareCustom squareColor={COLORS[index]} className="mr-3" />
                                                                    <span>{data.name}</span>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            : <div className="flex justify-center items-center text-lg font-medium h-64">
                                                <p className="text-darkgrey">Tidak ada data</p>
                                            </div>
                                    }
                                </div>
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default TicketTrendVolumeChartPrincipal;